module.exports = __webpack_public_path__ + "static/media/coding.e5638509.svg";